import * as React from "react";
import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
  desc?: string;
  descId?: string;
}
const SvgInsightfulAnalyticsIcon = ({
  title,
  titleId,
  desc,
  descId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 40 40"
    fill="currentColor"
    aria-hidden="true"
    data-slot="icon"
    width={24}
    height={24}
    aria-labelledby={titleId}
    aria-describedby={descId}
    {...props}
  >
    {desc ? <desc id={descId}>{desc}</desc> : null}
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeWidth={0.4}
      d="M23.047 13.438H17.03a.781.781 0 0 0-.781.78v18.36a.782.782 0 0 0 .781.781h6.016a.781.781 0 0 0 .781-.78v-18.36a.781.781 0 0 0-.781-.781Zm-.86 18.359h-4.375V21.25h4.375zm0-12.11h-4.375V15h4.375v4.688ZM33.281 6.64h-6.015a.781.781 0 0 0-.782.782v25.156a.782.782 0 0 0 .782.781h6.015a.781.781 0 0 0 .782-.78V7.421a.781.781 0 0 0-.782-.781ZM32.5 31.798h-4.453V14.453H32.5v17.344Zm0-18.906h-4.453V8.203H32.5v4.688Zm-19.766 5.311H6.72a.781.781 0 0 0-.782.781v13.672a.781.781 0 0 0 .782.782h6.015a.781.781 0 0 0 .782-.782V18.984a.782.782 0 0 0-.782-.78Zm-.78 13.594H7.5v-5.781h4.453v5.78Zm0-7.344H7.5v-4.687h4.453v4.687Z"
    />
  </svg>
);
export default SvgInsightfulAnalyticsIcon;
